
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.5 1.5H3.5C2.39543 1.5 1.5 2.39786 1.5 3.50542V22.6574C1.5 23.765 2.39543 24.6628 3.5 24.6628H9.412C10.0904 24.6628 10.7226 25.0077 11.0911 25.5788L14.3209 30.5838C15.109 31.8051 16.8911 31.8051 17.6792 30.5838L20.909 25.5788C21.2775 25.0077 21.9097 24.6628 22.5881 24.6628H28.5C29.6046 24.6628 30.5 23.765 30.5 22.6574V3.50542C30.5 2.39786 29.6046 1.5 28.5 1.5Z","stroke":"black"}}),_c('path',{attrs:{"d":"M15.4274 7.52968C7.44207 1.84641 2.018 13.2438 13.9282 21.3451C15.2119 22.2183 16.7881 22.2183 18.0718 21.3451C29.982 13.2438 24.5579 1.84641 16.5726 7.52968C16.222 7.77926 15.778 7.77926 15.4274 7.52968Z","fill":"#0093FF"}})])
          )
        }
      }
    